import React from "react";

export const ItemCardInfoBank = ({}) => {
	return (
		<div className="item-card-info-bank">
			<p className="item-card-info-bank--title">Por que precisamos dos seus dados bancários?</p>
			<p className="item-card-info-bank--first-text">
				É para esta conta que a MaxMilhas fará o pagamento das milhas utilizadas nas emissões.
			</p>
			<p className="item-card-info-bank--first-text">
				Para isso, é preciso cadastrar uma conta corrente que tenha o mesmo titular
				da conta na MaxMilhas.
			</p>
			<p className="item-card-info-bank--title">Sigilo e segurança dos seus dados</p>
			<p>
				Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em
				segurança. Aqui, seus dados estão protegidos.
			</p>
		</div>
	);
};
